import { selectChangeMessageForColor } from '@UI/aside/asideColor/asideColorSelectors';
import { selectChangeMessageForStringArray } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForStringArray';
import { selectThemeItemNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { themeReferencesWithRootsCmd } from '@store/commands/documentCommands';

const getThemeReferencesWithRootsCmd = (node) => ({
  cmd: themeReferencesWithRootsCmd,
  params: [node.$$meta.permalink],
  message: 'validation.themeReferenced',
});

const THEME: BuildingBlockNodeConfig = {
  nodeSelector: selectThemeItemNode,
  deleteValidations: [getThemeReferencesWithRootsCmd],
  information: {
    single: 'Item',
    plural: 'Items',
  },

  buildingBlocks: [
    { type: NodeType.THEME },
    { type: NodeType.CURRICULUM_CLUSTER },
    { type: NodeType.CURRICULUM_THEME },
  ],
  edit: [
    {
      ...titleComponent,
      width: 8,
    },
    {
      component: 'color',
      reactComponent: 'AsideColor',
      asideChangeMessageSelector: selectChangeMessageForColor,
      property: 'color',
      label: 'Kleur',
      width: 4,
    },
    {
      ...imageComponentBase,
      width: 6,
      label: 'Ikoon',
      options: {
        type: 'ICON',
      },
    },
    {
      component: 'subjects',
      property: 'subjects',
      reactComponent: 'AsideSubjects',
      label: 'Aliassen',
      asideChangeMessageSelector: selectChangeMessageForStringArray,
    },
  ],
  onNewNodeDropped: {
    focusOnField: 'title',
  },
  confirmDelete: true,
  isCollapsible: true,
  isCollapsedByDefault: false,
};

export default THEME;
